export abstract class ArchonTranslateLoaderConfig {
  public dictionaries: string[] = [];
  public dictionaryPath: string = '';
}
